import { AppUtils } from '../../utils/index';
import { MglArtApi } from '../generated/PersonMglArtApi';
import { AntragsstellerApi } from '../generated/MitgliedschaftAntragsstellerApi';
import { BankApi } from '../generated/PersonBankApi';
import { SimulationTypeApi } from '../generated/TypesSimulationTypeApi';
import { MitgliedschaftGutscheinKooperationApi } from '../generated/MitgliedschaftMitgliedschaftGutscheinKooperationApi';
import { ConsentWriteShortModelApi } from '../generated/ModelsConsentWriteShortModelApi';

export class MglBasisAnlage {

	private tarif: MglArtApi;
	/**
	 * Description: Mitgliedschaftstarif
	 * APIL Type: MglArt
	 */
	get Tarif(): MglArtApi {
		return this.tarif;
	}

	/**
	 * Description: Mitgliedschaftstarif
	 * APIL Type: MglArt
	 */
	set Tarif(value: MglArtApi) {
		this.tarif = value;
	}

	private beginn: string;
	/**
	 * Description: Beginn der Mitgliedschaft
	 * APIL Type: date
	 */
	get Beginn() {
		return this.beginn;
	}
	/**
	 * Description: Beginn der Mitgliedschaft
	 * APIL Type: date
	 */
	set Beginn(value: string) {
		this.beginn = value;
	}

	private agenturnummer: number;
	/**
	 * Description: Nummer der Argentur
	 * APIL Type: integer
	 */
	get Agenturnummer(): number {
		return this.agenturnummer;
	}

	/**
	 * Description: Nummer der Argentur
	 * APIL Type: integer
	 */
	set Agenturnummer(value: number) {
		this.agenturnummer = value;
	}

	private werbeschluessel: number;
	/**
	 * Description: Werbeschlüssel
	 * APIL Type: integer
	 */
	get Werbeschluessel(): number {
		return this.werbeschluessel;
	}

	/**
	 * Description: Werbeschlüssel
	 * APIL Type: integer
	 */
	set Werbeschluessel(value: number) {
		this.werbeschluessel = value;
	}

	private antragssteller: AntragsstellerApi;
	/**
	 * Description: Antragssteller
	 * APIL Type: Antragssteller
	 */
	get Antragssteller(): AntragsstellerApi {
		return this.antragssteller;
	}

	/**
	 * Description: Antragssteller
	 * APIL Type: Antragssteller
	 */
	set Antragssteller(value: AntragsstellerApi) {
		this.antragssteller = value;
	}

	private bankdaten: BankApi;
	/**
	 * Description: Bankdaten des Antragsstellers
	 * APIL Type: Bank
	 */
	get Bankdaten(): BankApi {
		return this.bankdaten;
	}

	/**
	 * Description: Bankdaten des Antragsstellers
	 * APIL Type: Bank
	 */
	set Bankdaten(value: BankApi) {
		this.bankdaten = value;
	}

	private widerrufAkzeptiert: boolean;
	/**
	 * Description: Wurde die Widerrufsbelehrung akzeptiert
	 * APIL Type: boolean
	 */
	get WiderrufAkzeptiert(): boolean {
		return this.widerrufAkzeptiert;
	}

	/**
	 * Description: Wurde die Widerrufsbelehrung akzeptiert
	 * APIL Type: boolean
	 */
	set WiderrufAkzeptiert(value: boolean) {
		this.widerrufAkzeptiert = value;
	}

	private bestimmungenAkzepiert: boolean;
	/**
	 * Description: Wurden die Bestimmungen zur Mitgliedschaft und die Leistungsordnung akzepiert
	 * APIL Type: boolean
	 */
	get BestimmungenAkzepiert(): boolean {
		return this.bestimmungenAkzepiert;
	}

	/**
	 * Description: Wurden die Bestimmungen zur Mitgliedschaft und die Leistungsordnung akzepiert
	 * APIL Type: boolean
	 */
	set BestimmungenAkzepiert(value: boolean) {
		this.bestimmungenAkzepiert = value;
	}

	private simulationType: SimulationTypeApi;
	/**
	 * Description: Gibt an was Simuliert werden soll
	 * APIL Type: SimulationType
	 */
	get SimulationType(): SimulationTypeApi {
		return this.simulationType;
	}

	/**
	 * Description: Gibt an was Simuliert werden soll
	 * APIL Type: SimulationType
	 */
	set SimulationType(value: SimulationTypeApi) {
		this.simulationType = value;
	}

	private inAusbildung: boolean;
	/**
	 * Description: Kunde ist in Ausbildung
	 * APIL Type: boolean
	 */
	get InAusbildung(): boolean {
		return this.inAusbildung;
	}

	/**
	 * Description: Kunde ist in Ausbildung
	 * APIL Type: boolean
	 */
	set InAusbildung(value: boolean) {
		this.inAusbildung = value;
	}

	private ausbildungsende: string;
	/**
	 * Description: Ausbildungsende wenn InAusbildung true ist.&#10;            Wurde ein Wert angegeben so wird dieser automatisch auf den letzten Tag im angegebenen Monat gesetzt
	 * APIL Type: date
	 */
	get Ausbildungsende(): string {
		return this.ausbildungsende;
	}

	/**
	 * Description: Ausbildungsende wenn InAusbildung true ist.&#10;            Wurde ein Wert angegeben so wird dieser automatisch auf den letzten Tag im angegebenen Monat gesetzt
	 * APIL Type: date
	 */
	set Ausbildungsende(value: string) {
		this.ausbildungsende = value;
	}

	private gutscheindaten: MitgliedschaftGutscheinKooperationApi;
	/**
	 * Description: Daten der Kooperation für die Mitgliedschaft Gutscheine
	 * APIL Type: MitgliedschaftGutscheinKooperation
	 */
	get Gutscheindaten(): MitgliedschaftGutscheinKooperationApi {
		return this.gutscheindaten;
	}

	/**
	 * Description: Daten der Kooperation für die Mitgliedschaft Gutscheine
	 * APIL Type: MitgliedschaftGutscheinKooperation
	 */
	set Gutscheindaten(value: MitgliedschaftGutscheinKooperationApi) {
		this.gutscheindaten = value;
	}

	protected userMailText: string;
	/**
	 * Description: Text der Mail an den User
	 * APIL Type: string
	 */
	get UserMailText(): string {
		return this.userMailText;
	}

	/**
	 * Description: Text der Mail an den User
	 * APIL Type: string
	 */
	set UserMailText(value: string) {
		this.userMailText = value;
	}

	protected attachments: string;
	/**
	 * Description: kommaseparierte Liste der IDs für die PDFs aus dem CMS
	 * APIL Type: string
	 */
	get Attachments(): string {
		return this.attachments;
	}

	/**
	 * Description: kommaseparierte Liste der IDs für die PDFs aus dem CMS
	 * APIL Type: string
	 */
	set Attachments(value: string) {
		this.attachments = value;
	}

	protected isBodyHtml: boolean;
	/**
	 * Description: Mail ist in Html
	 * APIL Type: boolean
	 */
	get IsBodyHtml(): boolean {
		return this.isBodyHtml;
	}

	/**
	 * Description: Mail ist in Html
	 * APIL Type: boolean
	 */
	set IsBodyHtml(value: boolean) {
		this.isBodyHtml = value;
	}

	protected mailBodyHtml: string;
	/**
	 * Description: Html Text der Mail an den User
	 * APIL Type: string
	 */
	get MailBodyHtml(): string {
		return this.mailBodyHtml;
	}

	/**
	 * Description: Html Text der Mail an den User
	 * APIL Type: string
	 */
	set MailBodyHtml(value: string) {
		this.mailBodyHtml = value;
	}

	protected subject: string;
	/**
	 * Description: Betreff der Mail an den User
	 * APIL Type: string
	 */
	get Subject(): string {
		return this.subject;
	}

	/**
	 * Description: Betreff der Mail an den User
	 * APIL Type: string
	 */
	set Subject(value: string) {
		this.subject = value;
	}

	protected consent: ConsentWriteShortModelApi;
	/**
	 * Description: Model für die Datenverwendung - Consent
	 * APIL Type: ConsentWriteShortModel
	 */
	get Consent(): ConsentWriteShortModelApi {
		return this.consent;
	}

	/**
	 * Description: Model für die Datenverwendung - Consent
	 * APIL Type: ConsentWriteShortModel
	 */
	set Consent(value: ConsentWriteShortModelApi) {
		this.consent = value;
	}

	private bisherigeMitgliedsnummer: string;
	/**
	 * Description: Bisherige Mitgliedsnummer
	 * APIL Type: string
	 */
	get BisherigeMitgliedsnummer(): string {
		return this.bisherigeMitgliedsnummer;
	}

	/**
	 * Description: Bisherige Mitgliedsnummer
	 * APIL Type: string
	 */
	set BisherigeMitgliedsnummer(value: string) {
		this.bisherigeMitgliedsnummer = value;
	}

	private validierungscode: string;
	public get Validierungscode(): string {
		return this.validierungscode;
	}
	public set Validierungscode(value: string) {
		this.validierungscode = value;
	}

	/**
	 * Returns the object as JSON string
	 */
	public toString(): string {
		try {
			return JSON.stringify(this);
		} catch (e) {
			return Object.toString.apply(this);
		}
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): MglBasisAnlage {
		return AppUtils.Helper.createFromMap(dataObject, MglBasisAnlage, (key: string, value: any) => {
			switch (key) {
				case 'antragssteller':
					return AntragsstellerApi.createFromObject(value);
				case 'bankdaten':
					return BankApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result = {} as { [key: string]: any };
		result.Tarif = this.tarif;
		result.Beginn = this.beginn;
		result.Agenturnummer = this.agenturnummer;
		result.Werbeschluessel = this.werbeschluessel;
		if (this.antragssteller) {
			result.Antragssteller = this.antragssteller.toRequestObject();
		}
		if (this.bankdaten) {
			result.Bankdaten = this.bankdaten.toRequestObject();
		}
		result.WiderrufAkzeptiert = this.widerrufAkzeptiert;
		result.BestimmungenAkzepiert = this.bestimmungenAkzepiert;
		result.SimulationType = this.simulationType;
		result.InAusbildung = this.inAusbildung;
		result.Ausbildungsende = this.ausbildungsende;
		if (this.gutscheindaten) {
			result.Gutscheindaten = this.gutscheindaten.toRequestObject();
		}
		if (this.userMailText) {
			result.UserMailText = this.userMailText;
		}
		if (this.attachments) {
			result.Attachments = this.attachments;
		}
		result.IsBodyHtml = this.isBodyHtml;
		if (this.mailBodyHtml) {
			result.MailBodyHtml = this.mailBodyHtml;
		}
		if (this.subject) {
			result.Subject = this.subject;
		}
		if (this.consent) {
			result.Consent = this.consent.toRequestObject();
		}
		if (this.bisherigeMitgliedsnummer) {
			result.BisherigeMitgliedsnummer = this.bisherigeMitgliedsnummer;
		}
		if (this.validierungscode) {
			result.Validierungscode = this.validierungscode;
		}
		return result;
	}

}
